<template>
  <div>
    <Form
      ref="addModel"
      :model="addModel"
      :rules="ruleValidate2"
      :label-width="100"
    >
      <FormItem label="设备SN" prop="clientSN">
        <Select v-model="addModel.clientSN" >
          <Option
            v-for="(item, index) in clientSNSelect"
            :value="item.clientSN"
            :key="index"
            >{{ item.clientSN }} - {{ item.clientName }}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="服务名" prop="parmTitle">
        <Select v-model="addModel.parmTitle">
          <Option
            v-for="(item, index) in parmTitleSelect"
            :value="item.dictionaryCode"
            :key="index"
            >{{ item.dictionaryValue }}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="服务类型" prop="parmType">
        <Select v-model="addModel.parmType">
          <Option
            v-for="(item, index) in parmTypeSelect"
            :value="item.tValue"
            :key="index"
            >{{ item.tName }}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="状态" prop="Status">
        <Select v-model="addModel.Status">
          <Option value="0" label="开启">开启</Option>
          <Option value="1" label="关闭">关闭</Option>
          <!-- <Option value="2">重启</Option> -->
        </Select>
      </FormItem>
      <!-- <FormItem label="key" prop="parmName">
        <Input v-model="addModel.parmName" placeholder="Key值"></Input>
      </FormItem> -->
      <FormItem label="value" prop="parmValue">
        <Input
          v-model="addModel.parmValue"
          placeholder="Value值"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 15 }"
        ></Input>
      </FormItem>
      <FormItem label="描述">
        <Input
          v-model="addModel.parmDescription"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')">
        确 定
      </Button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: function () {
    return {
      addModel: {
        clientSN: "",
        clientDetailID: "",
        organId: "",
        organCode: "",
        parmTitle: "",
        parmType: "",
        parmName: "",
        parmValue: "",
        parmDescription: "",
        Status: "1",
      },
      clientSNSelect: [],
      parmTitleSelect: [],
      parmTypeSelect: [
        { tName: "采集", tValue: "采集" },
        { tName: "同步", tValue: "同步" },
      ],

      ruleValidate2: {
        clientSN: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        parmTitle: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        parmType: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        Status: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        parmValue: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.getclientSNList();
    this.getXmlServiceNameList();
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    getclientSNList() {
      this.$api.get("clientDetail/getListAll").then((rsp) => {
        if (rsp != false) {
          this.clientSNSelect = rsp.data;
          console.log('clientSNSelect',this.clientSNSelect);
        }
      });
    },
    getXmlServiceNameList() {
      this.$common.getDictionaryByCode("9001").then((data) => {
        
        this.parmTitleSelect = data;
        console.log('parmTitleSelect',this.parmTitleSelect);
      });
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("clientXml/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
              this.$emit("search_fuwu");
              this.$Message.success("添加成功");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.addModel) {
        this.addModel[key] = "";
      }
      this.$refs["addModel"].resetFields();
    },

    projectChange(data) {
      var info = this.clientSNSelect.find((p) => p.clientDetailID == data);
      this.addModel.organId = info.organId;
      this.addModel.organCode = info.organCode;
      this.addModel.clientSN = info.clientSN;
    },
  },
};
</script>
<style scoped>
</style>